<template>
    <MainContent title="Listados bloqueos y aforo">
        <template v-slot:header>
            <h3 class="card-title">Listados bloqueos y aforo</h3>
        </template>
        <template v-slot:content>
            <b-card title="Listado Aforo" class="mb-3">
                <b-card-text class="mt-4">
                    <b-table hover responsive="sm" :items="ocupacion" :fields="fieldsOcupacion" id="listado-ocupacion"/>
                </b-card-text>
            </b-card>
            <b-card title="Cuadro de bloqueo">
                <b-card-text class="mt-5">
                    <div class="row">
                        <div class="input-group input-group-sm p-2 col-md-9">
                            <input type="search" name="table_search" class="form-control" placeholder="Buscar" v-model="filtros.search" @input="debouncedGetBloqueos()"/>
                    
                            <div class="input-group-append">
                                <Button @click="debouncedGetBloqueos()" type="submit" variant="default" icon="fas fa-search" />
                            </div>
                        </div>
                        <select class="custom-select w-auto mr-3" v-model="filtros.zona_id" @change="debouncedGetBloqueos()">
                            <option value="">Seleciona Region</option>
                            <option v-for="zona in zonas" :value="zona.id" :key="zona.id">{{ zona.name }}</option>
                        </select>
                    </div>
                    <b-table hover :items="bloqueos.data" :fields="fields" id="listado-bloqueos">
                        <template v-slot:cell(region)="row">
                            <span>{{ row.item.region.name }}</span>
                        </template>
                        <template v-slot:cell(row)="row">
                            <span>{{ row.item.row ? row.item.row : 'Sin Numerar' }}</span>
                        </template>
                        <template v-slot:cell(seat)="row">
                            <span>{{ row.item.seat ? row.item.seat : 'Sin Numerar' }}</span>
                        </template>
                        <template v-slot:cell(motivo)="row">
                            <span>{{ row.item.motivo ?? 0 }}</span>
                        </template>
                        <template v-slot:cell(id)="row">
                            <div class="btn-group">
                                <router-link :to="{
                                    name: 'back.events.sesion.bloquear-asientos',
                                    params: { evento_id: evento_id, sesion_id: sesion_id, zona: row.item.region },
                                }" class="btn btn-sm btn-primary"
                                >
                                    Ver region
                                </router-link>
                            </div>
                        </template>
                    </b-table>
                    <div class="d-md-flex">
                        <div class="d-md-flex" v-if="!loading">
                            <ElementosPorPaginaComponent @input="(n) => numPage = n" :value="numPage" />
                            <b-pagination 
                                v-model="filtros.currentPage"
                                :total-rows="bloqueos.meta.total"
                                :per-page="numPage"
                                first-number
                                last-number
                                @input="debouncedGetBloqueos"
                            />
                        </div>
                    </div>
                </b-card-text>
            </b-card>
        </template>
    </MainContent>
</template>


<script>
    import MainContent from '@/components/backend/components/MainContent.vue';
    import ElementosPorPaginaComponent from '@/components/backend/components/ElementosPorPaginaComponent.vue';
    export default {
        props: ['evento_id', 'sesion_id'],
        data(){
            return {
                filtros: {
                    per_page: 10,
                    page: 1,
                    search: "",
                    zona_id: "",
                    currentPage: 1,
                    rows: 0,
                },
                fields: [
                    { key: "region", label: "Región" },
                    { key: "row", label: "Fila" },
                    { key: "seat", label: "Asiento" },
                    { key: "motivo", label: "Concepto"},
                    { key: "id", label: "Acciones", class: "text-center" }
                ],
                fieldsOcupacion: [
                    {key: "name", label: "Sector"},
                    {key: "aforo", label: "Stock"},
                    {key: "bloqueos", label: "Bloqueos"},
                    {key: "vendidas", label: "Vendidas"},
                    {key: "libres", label: "Libres"},
                ],
                bloqueos: [],
                loading: false,
                debouncedGetBloqueos: null,
                zonas: [],
                zona: {},
                ocupacion: [],
                numPage: 5,
            }
        },
        created() {
            this.getOcupacion();
            this.getZonas();
            this.getBloqueos();
            this.debouncedGetBloqueos = _.debounce(this.getBloqueos, 500);
        },
        methods: {
            getBloqueos() {
                this.loading = true;
                var params = {
                    filters : {
                        evento_id : this.evento_id,
                        sesion_id : this.sesion_id,
                        zona_id : this.filtros.zona_id,
                        search : this.filtros.search,
                        page : this.filtros.currentPage,
                        per_page : this.numPage,
                    },
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                }


                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.listado-bloqueos'), params).then(res => {
                    this.filtros.rows = res.data.meta.last_page;
                    this.filtros.perPage = res.data.meta.per_page > 5 ? res.data.per_page : 1;
                    this.filtros.currentPage = res.data.meta.current_page;
                    this.bloqueos = res.data;
                }).finally(() => this.loading = false);
            },
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                }).finally(() => this.loading = false);
            },
            getOcupacion(){
                var params = {
                    filters : {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                }
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.listado-ocupacion'), params).then(res => {
                    this.ocupacion = res.data.data;
                    let totalObj = {
                        "name": "Total",
                        "aforo": 0,
                        "bloqueos": 0,
                        "vendidas": 0,
                        "libres": 0
                    };
                    this.ocupacion.forEach(zona => {
                        totalObj.aforo += parseInt(zona.aforo);
                        totalObj.bloqueos += parseInt(zona.bloqueos);
                        totalObj.vendidas += parseInt(zona.vendidas);
                        totalObj.libres += parseInt(zona.libres);
                    });
                    this.ocupacion.push(totalObj);
                }).catch(err => {
                    let totalObj = {
                        "name": "Total",
                        "aforo": 0,
                        "bloqueos": 0,
                        "vendidas": 0,
                        "libres": 0
                    };
                    this.ocupacion.push(totalObj);
                });
            },
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        components: {
            ElementosPorPaginaComponent, MainContent
        },
        watch: {
            numPage() {
                this.debouncedGetBloqueos();
            },
            currentPage() {
                this.debouncedGetBloqueos();
            },
            search(){
                this.debouncedGetBloqueos();
            }
        }
    }
</script>